import React from 'react';
import PropTypes from 'prop-types';
import {
  branch,
  compose,
  withProps,
  withHandlers,
} from 'recompose';
import Auth from '../Auth/index';
import { connectUserHeaderinfo } from '../Auth/WithUserHeaderInfo';
import { willShowModal } from '../Common/Modal/Modal';
import { HTMLTrans } from '../Common/Translations';

const withModal = willShowModal({ size: 'md' });

const withOnAddToCartHandler = withHandlers({
  onAddToCartHandler: ({ onAuthenticated }) => () => {
    onAuthenticated();
  },
});

export const hasLoginModal = (Comp) => {
  const Modal = withModal(Comp);

  return ({ onAddToCartHandler }) =>
    (
      <Modal>
        {closeModal => (
          <Auth
            closeModal={closeModal}
            onTokenUpdate={onAddToCartHandler}
          />
        )}
      </Modal>
    );
};

export const AddToCartButton = ({ onClick, disable }) => (
  <button type="button" className="btn btn-primary" onClick={onClick} disabled={disable}>
    <HTMLTrans id="configurable_product.addtocart_button">Add to cart</HTMLTrans>
  </button>
);

const isNotLoggedIn = ({ isLoggedIn }) => !isLoggedIn;

const withLoginModalIfUnauthenticated = compose(
  connectUserHeaderinfo,
  withProps(({ userHeaderInfo: { isLoggedIn } }) => ({ isLoggedIn })),
  withOnAddToCartHandler,
  branch(
    isNotLoggedIn,
    hasLoginModal,
  ),
);

AddToCartButton.propTypes = {
  onAuthenticated: PropTypes.func,
  onClick: PropTypes.func,
  disable: PropTypes.bool
};

const AuthenticableAddToCartButton = withLoginModalIfUnauthenticated(AddToCartButton);

export default AuthenticableAddToCartButton;



// WEBPACK FOOTER //
// ./src/ConfigurableProduct/AddToCartButton.js